/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var XCircleIcon20Light = forwardRef('XCircleIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.198 6.49a.5.5 0 1 0-.708.708L8.793 9.5 6.49 11.802a.5.5 0 0 0 .708.707L9.5 10.207l2.302 2.302a.5.5 0 1 0 .707-.707L10.207 9.5l2.302-2.302a.5.5 0 1 0-.707-.708L9.5 8.793 7.198 6.49Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 2a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM3 9.5a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0Z" })));
});
